// extracted by mini-css-extract-plugin
export default {"dark":"EventList_dark__z9qvO","links":"EventList_links__VtNfR","link":"EventList_link__2482X","light":"EventList_light__0Oa+w","remove_event":"EventList_remove_event__goAxT"};